import React from "react";

const achievementsContent = [
  { title: "20", class:"", subTitle1: "years of ", subTitle2: "experience" },
  { title: "760",class:"", subTitle1: "financial", subTitle2: "statements" },
  { title: "140",class:"no-margin-bottom", subTitle1: "audit", subTitle2: "reports" },
  { title: "150",class:"no-margin-bottom", subTitle1: "satisfied", subTitle2: "clients" },
];

const AchievementsEn = () => {
  return (
    <div className="row">
      {achievementsContent.map((val, i) => (
        <div className="col-6" key={i}>
          <div className={`box-stats with-margin ${val.class}`}>
            <h3 className="poppins-font position-relative">{val.title}</h3>
            <p className="open-sans-font m-0 position-relative text-uppercase">
              {val.subTitle1} <span className="d-block">{val.subTitle2}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AchievementsEn;
